<template lang="pug">
div(class="modal" role="dialog" tabindex="-1" style="display:block;" aria-hidden="true")
  div(class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document")
    div(class="modal-content")
      div(class="modal-header")
        SectionTitle(:sectionText="sectionText")
      div(class="modal-body")
        .popup-item
          textarea(
            :class="alert.content.textarea" 
            rows=4
            maxlength="200" 
            placeholder='請輸入正確闢謠解釋' 
            @input="checkActive" 
            v-model="params.content")
          .popup-alertText(v-if="alert.content.alertText") 已達字數上限
          div(:class="alert.content.counter")
            span.popup-remainingCounter {{ params.content.length }}
            span.popup-limitCounter {{ contentLimit }}
        .popup-item.popup-item--wrapColumn
          span.popup-text 查核結果
          Dropdown(:id="componentId" placeholder="請選擇" :selectText='judgement' innerTextClass="popup-option-innerText" :infos="infos" optionClass="popup-option" @selectDropdown="selectDropdown")
        .popup-item.popup-item--wrapColumn
          span(:class="alert.web.text") 網頁連結URL
          input(:class="alert.web.input" placeholder="完整查核報告連結" @input="checkActive" v-model="params.url")
          .popup-alertText(v-if="alert.web.alertText" style="bottom: -16px;") 格式不符合
        .popup-item
          .popup-imageAddArticle
            img.responsive(id="articleImage" :src="previewImgURL" alt="" style='height: 100%; width: 100%; object-fit: cover')
            Loading(loader="dots" :active.sync="isLoading" :is-full-page="false")
          div(:class="alert.image.inputArea")
            span(:class="alert.image.text") 圖片連結URL
            input(:class="alert.image.input" placeholder="圖片連結URL" @input="checkIfValidImgURL" v-model="params.thumbnailUrl")
            .popup-alertText(v-if="alert.image.alertText" style="bottom: -9px;") 格式不符合
      div(class="modal-footer")
        PopupButtonsOnBottom(:isActive="isActive" :isScrollablePopup='true' :isSingleButton='false' @send="send" @cancel="closePopup")
</template>

<script>
import SectionTitle from '@/components/modules/section_title/section_title.vue';
import Dropdown from '@/components/modules/dropdown.vue';
import PopupButtonsOnBottom from '@/components/popup/popup-buttons-on-bottom.vue';
import Loading from 'vue-loading-overlay';
import {
  lockBody,
  unlockBody,
  checkPopupAlert,
  getCategoryImgURL,
  getImgURL
} from '@/plugins/tool.js';
import { isValidURL } from '@/plugins/format_check.js';
import qs from 'qs';

export default {
  components: {
    SectionTitle,
    Dropdown,
    PopupButtonsOnBottom,
    Loading
  },
  props: {
    articleId: Number,
    sectionText: String,
    type: String,
    comment: Object
  },
  data() {
    return {
      infos: [],
      isActive: false,
      isProcessing: false,
      judgement: '',
      params: {
        content: '',
        judgementId: '',
        url: '',
        thumbnailUrl: ''
      },
      contentLimit: 200,
      componentId: '',
      alert: {
        content: {
          textarea: 'popup-textarea',
          counter: 'popup-counter',
          alertText: false
        },
        web: {
          text: 'popup-text',
          input: 'popup-input',
          alertText: false
        },
        image: {
          inputArea: 'popup-inputAreaAddArticle',
          text: 'popup-text',
          input: 'popup-input',
          alertText: false
        }
      },
      getImgURL: getImgURL,
      hasSent: false,
      isValidImgURL: null,
      isLoading: false
    };
  },
  mounted() {
    lockBody();
  },
  created() {
    if (this.type == 'edit') {
      this.params.content = this.comment.content;
      this.params.judgementId = this.comment.judgement.id;
      this.params.url = this.comment.url;
      this.params.thumbnailUrl = this.comment.thumbnailUrl;
      this.judgement = this.comment.judgement[this.$store.state.lang];
      this.componentId = this.type + '-' + this.comment.id;
      this.isValidImgURL = true;
    } else {
      this.componentId = this.type;
      this.checkIfValidImgURL();
    }
    this.getInfo();
    this.checkActive();
  },
  computed: {
    previewImgURL() {
      if (!this.isValidImgURL) return getCategoryImgURL('/fig-default-2.png');
      else return this.params.thumbnailUrl;
    }
  },
  methods: {
    async getInfo() {
      let route =
        this.$store.state.URLs.api + this.$store.state.routes.judgements;
      let result = await this.$axios.get(route);
      this.infos = result.data;
      this.infos.forEach(info => {
        info.name = info[this.$store.state.lang];
      });
    },
    checkActive() {
      if (this.hasSent) this.checkPopupAlert();
      this.alert.content = checkPopupAlert(
        this.params.content.length > this.contentLimit,
        this.alert.content
      );
      if (
        this.params.content &&
        this.params.content.length <= this.contentLimit &&
        this.params.judgementId &&
        this.params.url &&
        this.params.thumbnailUrl &&
        this.isValidImgURL != null
      )
        this.isActive = true;
      else this.isActive = false;
    },
    selectDropdown(event) {
      this.params.judgementId = event.id;
      this.judgement = event.name;
      this.checkActive();
    },
    closePopup() {
      this.hasSent = false;
      unlockBody();
      this.$emit('closePopup');
    },
    async send() {
      if (!this.isActive || this.isProcessing) return;
      this.isProcessing = true;
      this.hasSent = true;
      if (!this.checkPopupAlert()) return;
      let route;
      if (this.type == 'edit')
        route =
          this.$store.state.URLs.apiPartner +
          '/articles/' +
          this.articleId +
          '/comments/' +
          this.comment.id;
      else
        route =
          this.$store.state.URLs.apiPartner +
          '/articles/' +
          this.articleId +
          '/comments';
      this.$axios
        .post(route, qs.stringify(this.params), {
          headers: {
            'X-Line-Biz-Session': localStorage.getItem(
              this.$store.state.storageKeys.token
            ),
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        })
        .then(() => {
          this.isProcessing = false;
          this.closePopup();
          window.location.reload();
          this.$emit('isSuccess');
        })
        .catch(() => {
          this.isProcessing = false;
          this.closePopup();
          this.$emit('isError');
        });
    },
    checkPopupAlert() {
      this.alert.web = checkPopupAlert(
        !isValidURL(this.params.url),
        this.alert.web
      );
      this.alert.image = checkPopupAlert(!this.isValidImgURL, this.alert.image);
      if (!isValidURL(this.params.url) || !this.isValidImgURL) return false;
      else return true;
    },
    checkIfValidImgURL() {
      this.isValidImgURL = null;
      this.isLoading = true;
      var imgsrc = this.params.thumbnailUrl;
      var pattern = /^((https):\/\/)/;
      if (!pattern.test(imgsrc)) {
        this.imgError();
        return;
      }
      var img = new Image();
      img.onerror = this.imgError;
      img.onload = this.imgLoad;
      img.src = imgsrc;
    },
    imgError() {
      this.isValidImgURL = false;
      this.isLoading = false;
      this.checkActive();
    },
    imgLoad() {
      this.isValidImgURL = true;
      this.isLoading = false;
      this.checkActive();
    }
  }
};
</script>
<style scoped src="../../assets/koromo_min.css">
.vld-overlay {
  width: 89px;
  opacity: 0.5;
}
</style>
